import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import CancelIcon from "@mui/icons-material/Close";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import ExcelIcon from "./../../../Assests/excel.svg";
import DownloadIcon from "./../../../Assests/download.svg";
import InfoIcon from "@mui/icons-material/Info";
import CancelIconRed from "./../../../Assests/cancel.svg";
import {
  Button,
  Grid,
  DialogActions,
  DialogContent,
  Box,
  Modal,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import {
  addPackingPlantAddMinorIngredient,
  addProcessingPackagingPlantsDiff,
  addSourceBePartOfOptimization,
  handleTemplateLTDownLoadByType,
  handleExistingTemplateDownLoad,
} from "../../../Redux/Actions/InputData";
import React, { useEffect, useRef, useState } from "react";
import {
  API_BASE_URL,
  LONG_EXCEL_FILE_UPLOAD_API,
} from "../../../Utils/Config";
import { getRequest } from "../../../Services/AxiosConfiguration";
import * as actions from "../../../Redux/Actions/index";
import axios from "axios";
import { ActivateOrDeactivateFolder } from "../../../Services/FolderService";

const BootstrapDialog = styled(Dialog)(({ theme }: any) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface LongTermUploadContentProps {
  isOpen: boolean;
  onClose: () => void;
  selectedFolderId: any;
  selectedScenarioId: any;
  handleGoBack: () => void;
  selectRadio: string;
  showCrossMark?: boolean;
  /** When true, renders body without wrapping Dialog (for embedding in another modal) */
  embedded?: boolean;
  /** When provided, used as authoritative module (e.g. "module6") - avoids Redux sync issues */
  moduleKey?: string;
}

function LongTermUploadContent(props: LongTermUploadContentProps) {
  const { moduleKey: moduleKeyProp } = props;
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const isDone = useSelector(
    (state: any) => state.InputDataReducers.isDone,
  );
  const isLoading = useSelector(
    (state: any) => state.InputDataReducers.isLoading,
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );
  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );
  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData,
  );

  const dispatch: any = useDispatch();

  const getDataArr: any = [
    {
      id: 1,
      name: "Upload Module 1 File",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const getDataModule2: any = [
    {
      id: 1,
      name: "Upload Module 2 File",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const getDataModule3: any = [
    {
      id: 1,
      name: "Upload Module 3 File",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const getDataModule4: any = [
    {
      id: 1,
      name: "Upload Module 4 File",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const getDataModule5: any = [
    {
      id: 1,
      name: "Upload Module 5 File",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const getDataModule6: any = [
    {
      id: 1,
      name: "Upload Module 6 File",
      btnName: "upload",
      selectedFile: {},
      ref: React.useRef(null),
    },
  ];

  const [selectedfileList, setSelectedFileList] = useState<any>([]);
  const [selectedfilesList, setSelectedFilesList] = useState<any>([]);
  const [getMasterData, setGetMasterData] = useState<any>([]);
  const [getData, setMasterData] = useState<any>([]);
  const [ModuleForUpload, setModuleForUpload] = useState<any>("");
  const [isLongTermPopup, SetIsLongTermPopup] = useState<any>(false);
  const [selectedfile, setSelectedFile] = useState<any>({});
  const [isDownloadingTemplate, setIsDownloadingTemplate] = useState(false);

  const handleTemplateDownLoad = async () => {
    const fileModule = ModuleForUpload;
    if (!fileModule || isDownloadingTemplate) return;
    setIsDownloadingTemplate(true);
    try {
      await handleTemplateLTDownLoadByType(fileModule);
    } finally {
      setIsDownloadingTemplate(false);
    }
  };

  const handleRerunTemplateDownLoad = async () => {
    if (isDownloadingTemplate) return;
    setIsDownloadingTemplate(true);
    try {
      await handleExistingTemplateDownLoad(
        selectedFolderId,
        selectedScenarioId,
      );
    } finally {
      setIsDownloadingTemplate(false);
    }
  };

  const handleChangeFileUpload = (e: any) => {
    selectedfileList.length = 0;
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) {
      return;
    }
    selectedfileList.push(fileUploaded.name);
    selectedfilesList.push({
      filename: fileUploaded.name,
      filedata: fileUploaded,
    });
    const newArr = getMasterData.map((ele: any) => {
      if (selectedItemId === ele.id) {
        ele.selectedFile = fileUploaded;
      }
      return ele;
    });
    setGetMasterData(newArr);
    setSelectedFile(fileUploaded);
  };
  const [selectedItemId, setSelectedItemId] = useState<any>("");

  const getIsProcessingPackagingPlantsDiff = useSelector(
    (state: any) => state.InputDataReducers.isProcessingPackagingPlantsDiff,
  );

  const getIsSourceBePartOfOptimization = useSelector(
    (state: any) => state.InputDataReducers.isSourceBePartOfOptimization,
  );

  const getIsPackingPlantAddMinorIngredient = useSelector(
    (state: any) => state.InputDataReducers.isPackingPlantAddMinorIngredient,
  );
  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);

  const setModules = () => {
    const normalizedFolderModule = folderModuleName?.toLowerCase?.();
    const moduleFromFolder =
      normalizedFolderModule && /^module[1-6]$/.test(normalizedFolderModule)
        ? normalizedFolderModule
        : null;
    const resolvedModule =
      moduleKeyProp && /^module[1-6]$/.test(moduleKeyProp)
        ? moduleKeyProp
        : moduleFromFolder;

    if (resolvedModule) {
      const moduleDataMap: Record<string, any> = {
        module1: getDataArr,
        module2: getDataModule2,
        module3: getDataModule3,
        module4: getDataModule4,
        module5: getDataModule5,
        module6: getDataModule6,
      };
      const data = moduleDataMap[resolvedModule];
      if (data) {
        setMasterData(data);
        setGetMasterData(data);
        setModuleForUpload(resolvedModule);
        return;
      }
    }

    if (
      getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      getIsPackingPlantAddMinorIngredient
    ) {
      setMasterData(getDataArr);
      setGetMasterData(getDataArr);
      setModuleForUpload("module1");
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      getIsPackingPlantAddMinorIngredient
    ) {
      setMasterData(getDataModule2);
      setGetMasterData(getDataModule2);
      setModuleForUpload("module2");
    } else if (
      !getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setMasterData(getDataModule3);
      setGetMasterData(getDataModule3);
      setModuleForUpload("module3");
    } else if (
      !getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setMasterData(getDataModule4);
      setGetMasterData(getDataModule4);
      setModuleForUpload("module4");
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setMasterData(getDataModule5);
      setGetMasterData(getDataModule5);
      setModuleForUpload("module5");
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setMasterData(getDataModule6);
      setGetMasterData(getDataModule6);
      setModuleForUpload("module6");
    }
  };

  useEffect(() => {
    setModules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    moduleKeyProp,
    folderModuleName,
    getIsProcessingPackagingPlantsDiff,
    getIsSourceBePartOfOptimization,
    getIsPackingPlantAddMinorIngredient,
  ]);

  const handleUploadFile = (e: any, item: any, index: number) => {
    e.preventDefault();
    getData[index]?.ref?.current?.click();
    setSelectedItemId(item.id);
  };

  const handleCancelFile = (e: any, elem: any) => {
    const newArr = getMasterData?.filter((ele: any) => {
      if (ele.id === elem.id) {
        ele.selectedFile = {};
      }
      return ele;
    });
    setGetMasterData(newArr);
  };

  const [rerunUploadStatusData, setRerunUploadStatusData] = useState<any>([]);
  const [longTermExcelStatus, setLongTermExcelStatus] = useState<any>(false);
  const [intervalId, setIntervalId] = useState<any>(null);
  const [openReRunDialogStatus, setOpenReRunDialogStatus] = useState<any>("");
  let failedCount = 0;
  let successCount = 0;
  const [progressBarStatus, setProgressBarStatus] = useState<any>(false);
  const [failedStatus, setFailedStatus] = useState<any>(false);
  const [successStatus, setSuccessStatus] = useState<any>(false);
  const uploadInitiatedRef = useRef(false);

  useEffect(() => {
    if (isDone && uploadInitiatedRef.current) {
      uploadInitiatedRef.current = false;
      handleReRunDialog(true);
    }
  }, [isDone]);

  const clearUploadModuleStore = () => {
    dispatch(addProcessingPackagingPlantsDiff(true));
    dispatch(addSourceBePartOfOptimization(true));
    dispatch(addPackingPlantAddMinorIngredient(true));
  };

  const handleOpenApicall = (urls: any, requestParam: any) => {
    axios({
      url: urls,
      method: "post",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      if (response.status === 200) {
        setRerunUploadStatusData(response.data);
        setProgressBarStatus(true);
        const rerunData = response.data;
        rerunData?.forEach((item: any) => {
          if (
            item?.status.toLowerCase().includes("failed") ||
            item?.status.toLowerCase().includes("fail")
          ) {
            setOpenReRunDialogStatus(item?.errorMessage);
            failedCount = failedCount + 1;
          } else if (item?.status.toLowerCase().includes("completed")) {
            setOpenReRunDialogStatus(item?.status);
            successCount = successCount + 1;
          }
        });

        if (response.data[1].status === "Module Run Successfully Completed") {
          setSuccessStatus(true);
          setProgressBarStatus(false);
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
        if (failedCount > 0) {
          setProgressBarStatus(false);
          ActivateOrDeactivateFolder(selectedUsecaseId, selectedFolderId, 0);
          setFailedStatus(true);
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
        if (response?.data?.length === successCount) {
          setProgressBarStatus(false);
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
        }
      }
    });
  };

  const handleFileUploadApi = () => {
    const folderNumber = ModuleForUpload.toLowerCase().replace("module", "");
    const urls = API_BASE_URL + LONG_EXCEL_FILE_UPLOAD_API;
    const requestParam = {
      folder_Id: Number(props?.selectedFolderId),
      scenario_Id: Number(props?.selectedScenarioId),
      module_Id: Number(folderNumber),
    };

    const apicallInterval = setInterval(() => {
      handleOpenApicall(urls, requestParam);
    }, 20000);
    setIntervalId(apicallInterval);
  };

  const handleCloseExcelPopup = () => {
    setLongTermExcelStatus(false);
    localStorage.setItem("selectCGOInput", "LongTermInput");
    localStorage.setItem("selectedUsecase", "Long Term Analysis");
    window.location.href = "/LongTermHome";
    setFailedStatus(false);
    setSuccessStatus(false);
  };

  const handleReRunDialog = (done: boolean) => {
    SetIsLongTermPopup(false);
    setLongTermExcelStatus(done);
    handleFileUploadApi();
  };

  const handleUploadNow = (e: any, runType: string) => {
    e.preventDefault();
    const formData = new FormData();
    getMasterData.forEach((itm: any) => {
      if (itm.selectedFile && itm.selectedFile.name) {
        formData.append("files", itm.selectedFile);
      }
    });

    const fileModule = ModuleForUpload;
    const fileType =
      folderModuleName === "module1"
        ? 5
        : folderModuleName === "module2"
          ? 9
          : folderModuleName === "module3"
            ? 11
            : folderModuleName === "module4"
              ? 13
              : folderModuleName === "module5"
                ? 15
                : 17;
    let MKey;
    if (
      getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module1");
      MKey = 1;
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module2");
      MKey = 2;
    } else if (
      !getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module3");
      MKey = 3;
    } else if (
      !getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module4");
      MKey = 4;
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module5");
      MKey = 5;
    } else if (
      getIsProcessingPackagingPlantsDiff &&
      !getIsSourceBePartOfOptimization &&
      !getIsPackingPlantAddMinorIngredient
    ) {
      setModuleForUpload("module6");
      MKey = 6;
    }
    const initialValues = {
      folder: props?.selectedFolderId,
      scenario: props?.selectedScenarioId,
      folderModuleName_id: Number(
        folderModuleName?.replace("module", "") ?? MKey,
      ),
    };
    dispatch(
      actions.onInitUloadMasterFile(
        formData,
        selectedfilesList,
        fileType,
        initialValues,
        "type",
        fileModule,
        "longTerm",
        runType,
        userData.userId,
      ),
    );
    setSelectedFilesList([]);
    uploadInitiatedRef.current = true;
  };

  const body = (
    <>
      <div style={{ paddingTop: "24px", paddingLeft: "20px" }}>
        <Grid container spacing={1}>
          <Grid item xs={10} md={10} lg={10}>
            {/* <h3>Nakshatra</h3> */}
            <h4>Upload the Long Term file</h4>
          </Grid>
          {props.showCrossMark && (
            <Grid item xs={2} md={2} lg={2}>
              <CancelIcon
                className="cancel-icon"
                onClick={() => {
                  props.onClose();
                  clearUploadModuleStore();
                }}
              />
            </Grid>
          )}
        </Grid>
      </div>
      {props.selectRadio === "masterData" ? (
        <>
          <DialogContent className="modal-body">
            <div className="upload-file-button">
              {getMasterData &&
                getMasterData?.map((ele: any, index: any) => {
                  return (
                    <Grid
                      container
                      spacing={1}
                      key={index}
                      className="uploadFile"
                    >
                      <Grid item xs={7} md={7} lg={7}>
                        {/* <span>
                          {index + 1}
                          {". "}
                        </span> */}
                        <span> {ele.name}</span>
                      </Grid>
                      <Grid item xs={5} md={5} lg={5}>
                        <>
                          {ele.selectedFile &&
                          ele.selectedFile?.name?.length > 0 ? (
                            <div className="seletcedFilename">
                              <img src={ExcelIcon} alt="" />{" "}
                              <span>{ele.selectedFile?.name}</span>{" "}
                              <span
                                className="cancel-file"
                                onClick={(e) => handleCancelFile(e, ele)}
                              >
                                <img src={CancelIconRed} alt="" />
                              </span>
                            </div>
                          ) : (
                            <>
                              <Button
                                variant="outlined"
                                className="uploadBtn"
                                onClick={(e) => handleUploadFile(e, ele, index)}
                              >
                                <img src={ExcelIcon} alt="ExcelIcon" />
                                {ele.btnName}
                              </Button>
                              <input
                                type="file"
                                id={"prefix_" + index}
                                ref={ele.ref}
                                style={{ display: "none" }}
                                multiple
                                onChange={(e) => handleChangeFileUpload(e)}
                              />
                            </>
                          )}
                        </>
                      </Grid>
                    </Grid>
                  );
                })}
            </div>
            <div
              className="download-templet"
              onClick={
                isDownloadingTemplate ? undefined : handleTemplateDownLoad
              }
              style={{
                cursor: isDownloadingTemplate ? "not-allowed" : "pointer",
                opacity: isDownloadingTemplate ? 0.8 : 1,
              }}
            >
              <a>
                {isDownloadingTemplate ? (
                  <CircularProgress size={18} sx={{ mr: 1 }} />
                ) : (
                  <img src={ExcelIcon} alt="" />
                )}{" "}
                <span> Download template </span>{" "}
                {!isDownloadingTemplate && <img src={DownloadIcon} alt="" />}
              </a>
              <p>Download the file with multiple sheets.</p>
            </div>
            {/* <div className="note-area-upload">
              <div className="note">
                <InfoIcon className="noteinfoicon" />
                <span>Note</span>
              </div>
              <div className="note-upload-content">
                <p>
                  All validations must pass only then the data will be loaded.
                </p>
                <p>File must be lesser than 100 MB.</p>
                <p>Only excel files are supported</p>
              </div>
            </div> */}
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="contained"
                  className="Next"
                  onClick={(e) => handleUploadNow(e, "newrun")}
                  disabled={isLoading}
                  startIcon={
                    isLoading ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : null
                  }
                >
                  {isLoading ? "Uploading..." : "Upload Now"}
                </Button>
              </div>
            </DialogActions>
          </DialogContent>
        </>
      ) : (
        <>
          <DialogContent className="modal-body">
            <div className="upload-file-button">
              {getMasterData &&
                getMasterData?.map((ele: any, index: any) => {
                  return (
                    <Grid
                      container
                      spacing={1}
                      key={index}
                      className="uploadFile"
                    >
                      <Grid item xs={7} md={7} lg={7}>
                        <span>
                          {index + 1}
                          {". "}
                        </span>
                        <span> {ele.name}</span>
                      </Grid>
                      <Grid item xs={5} md={5} lg={5}>
                        <>
                          {ele.selectedFile &&
                          ele.selectedFile?.name?.length > 0 ? (
                            <div className="seletcedFilename">
                              <img src={ExcelIcon} alt="" />{" "}
                              <span>{ele.selectedFile?.name}</span>{" "}
                              <span
                                className="cancel-file"
                                onClick={(e) => handleCancelFile(e, ele)}
                              >
                                <img src={CancelIconRed} alt="" />
                              </span>
                            </div>
                          ) : (
                            <>
                              <Button
                                variant="outlined"
                                className="uploadBtn"
                                onClick={(e) => handleUploadFile(e, ele, index)}
                              >
                                <img src={ExcelIcon} alt="ExcelIcon" />
                                {ele.btnName}
                              </Button>
                              <input
                                type="file"
                                id={"prefix_" + index}
                                ref={ele.ref}
                                style={{ display: "none" }}
                                multiple
                                onChange={(e) => handleChangeFileUpload(e)}
                              />
                            </>
                          )}
                        </>
                      </Grid>
                    </Grid>
                  );
                })}
            </div>
            <div
              className="download-templet"
              onClick={
                isDownloadingTemplate ? undefined : handleRerunTemplateDownLoad
              }
              style={{
                cursor: isDownloadingTemplate ? "not-allowed" : "pointer",
                opacity: isDownloadingTemplate ? 0.8 : 1,
              }}
            >
              <a>
                {isDownloadingTemplate ? (
                  <CircularProgress size={18} sx={{ mr: 1 }} />
                ) : (
                  <img src={ExcelIcon} alt="" />
                )}{" "}
                <span> Download template </span>{" "}
                {!isDownloadingTemplate && <img src={DownloadIcon} alt="" />}
              </a>
              <p>Download the file with multiple sheets and data.</p>
            </div>
            {/* <div className="note-area-upload">
              <div className="note">
                <InfoIcon className="noteinfoicon" />
                <span>Note</span>
              </div>
              <div className="note-upload-content">
                <p>
                  All validations must pass only then the data will be loaded.
                </p>
                <p>File must be lesser than 100 MB.</p>
                <p>Only excel files are supported</p>
              </div>
            </div> */}
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="contained"
                  className="Next"
                  onClick={(e) => handleUploadNow(e, "rerun")}
                  disabled={isLoading}
                  startIcon={
                    isLoading ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : null
                  }
                >
                  {isLoading ? "Uploading..." : "Upload Now"}
                </Button>
              </div>
            </DialogActions>
          </DialogContent>
        </>
      )}
    </>
  );

  return (
    <div>
      {longTermExcelStatus && (
        <Modal
          open={longTermExcelStatus}
          onClose={() => {}}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          className="done-modal"
        >
          <>
            <DialogContent data-keyboard="false" data-backdrop="static">
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 600,
                  bgcolor: "background.paper",
                  border: "2px solid #000",
                  boxShadow: 24,
                  p: 4,
                  height: 400,
                  overflowY: "auto",
                }}
              >
                <Box>
                  <p>
                    {(failedStatus || successStatus) && (
                      <>
                        <CancelIcon
                          className="cancel-icon"
                          onClick={handleCloseExcelPopup}
                        />
                      </>
                    )}
                  </p>
                  {progressBarStatus && (
                    <Box>
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    </Box>
                  )}

                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>File Name</TableCell>
                          <TableCell>File Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rerunUploadStatusData?.map((item: any) => (
                          <TableRow>
                            <TableCell>{item.fileName}</TableCell>
                            <TableCell>{item.status}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                {openReRunDialogStatus
                  ?.toLowerCase()
                  ?.includes("successfully") ? (
                  <>
                    <h6>{openReRunDialogStatus}</h6>
                    <br />
                  </>
                ) : !openReRunDialogStatus
                    ?.toLowerCase()
                    ?.includes("failed") ? (
                  <>
                    <h6 className="error-modal-message">
                      {openReRunDialogStatus}
                    </h6>
                    <br />
                  </>
                ) : (
                  <></>
                )}
              </Box>
            </DialogContent>
          </>
        </Modal>
      )}

      {isLongTermPopup && (
        <Modal
          open={isLongTermPopup}
          onClose={() => {}}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
            }}
          >
            <h2
              style={{ alignItems: "center", textAlign: "center" }}
              id="modal-title"
            >
              Files Uploaded Successfully!
            </h2>
            <div style={{ alignItems: "center", textAlign: "center" }}>
              <Button onClick={() => handleReRunDialog(true)}>Close</Button>
            </div>
          </Box>
        </Modal>
      )}

      {props.embedded ? (
        body
      ) : (
        <div>
          <BootstrapDialog
            onClose={props.onClose}
            aria-labelledby="customized-dialog-title"
            open={props.isOpen}
          >
            {body}
          </BootstrapDialog>
        </div>
      )}
    </div>
  );
}

export default LongTermUploadContent;
